<template>
  <el-divider direction="vertical" style="height: 100%;width:100%;margin: 0;" :style="{backgroundColor:chartConfig.backgroundColor}"></el-divider>
</template>

<script>
  export default {
    props: {
      chartConfig: {
        type: Object,
        default: function() {
          return {
            backgroundColor: '#DCDFE6',
          }
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/text/DeviderV.vue